import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { interpolateParams } from 'src/app/shared/utilities/interpolate-params';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';
import { combine } from 'src/app/shared/utilities/route';
import { Job } from '../models/job.model';
import { MarginCalculatorBaseService } from './margin-calculator-base.service';

@Injectable({
    providedIn: 'root'
})
export class MarginCalculatorJobService extends MarginCalculatorBaseService {
    private readonly _jobReceived = new Subject<Job>();

    constructor(
        private readonly _http: HttpClient,
    ) {
        super();
    }

    set jobReceived(job: Job) {
        this._jobReceived.next(job);
    }

    get jobReceived$(): Observable<Job> {
        return this._jobReceived.asObservable();
    }

    getJobInfo(jobId: number, candidateId?: number): Observable<Job> {
        if (isEmpty(jobId)) {
            return null;
        }

        const path = `${this.coreApiPath}/margin-calculator/job-info?jobId=${jobId}`;

        return this._http.get<Job>(path).pipe(
            map((response) => {
                if (candidateId) {
                    response.candidateId = candidateId;
                }
                this.jobReceived = response;
                return this.jobReceived;
            })
        );
    }

    getJob(jobId: number, candidateId?: number): Observable<Job> {
        const url = combine(this.coreApiPath, 'margin-calculator/job-info');
        const params = interpolateParams({ jobId });
        return this._http.get<Job>(url, { params }).pipe(
            tap((response) => {
                response.candidateId = candidateId;
            })
        );
    }
}
